import * as Yup from 'yup';
import {Probs, ProbsError} from '~/lib/errors/problemDetails';
import {ID, IModel} from '~/lib/model';
import {ISessionRoles} from '~/modules/Profile/session';
import {UserRole} from '~/modules/Users/models/User';

export interface IPreTargetingVariable {
    preTargetingConfigId?: ID;
    name: string;
    value: string;
}

export interface IPreTargetingConfig extends IModel {
    bidderId: ID;
    title: string;
    priority: number;
    active: boolean;
    allowCache: boolean;
    allowCloseDelay: number;
}

export const PreTargetingSchema = (roles: ISessionRoles) => Yup.object().shape<IPreTargetingConfig>({
    id: Yup.number().nullable(),
    bidderId: Yup.number().nullable().required(),
    title: Yup.string().required(),
    priority: Yup.number().min(0),
    active: Yup.boolean(),
    allowCache: Yup.boolean(),
    allowCloseDelay: Yup.number().min(0)
});

export const defaultPreTargeting: IPreTargetingConfig = {
    id: null,
    bidderId: null,
    title: '',
    priority: 0,
    active: false,
    allowCache: false,
    allowCloseDelay: 0
};

export const defaultPreTargetingVariable: IPreTargetingVariable = {
    name: '',
    preTargetingConfigId: 0,
    value: '[]'
};

export const VariableValueSchema = Yup.mixed<UserRole>().test({
    name: 'value',
    test: (value: string) => {
        try {
            JSON.parse(value);
            return true;
        } catch {
            return false;
        }
    },
    message: 'must be like JSON value'
}).required('required');


export const PreTargetingVariableSchema = Yup.object().shape<IPreTargetingVariable>({
    name: Yup.string().required(),
    value: VariableValueSchema
});

export interface IPreTargetingProbsError extends ProbsError {
    line?: number;
    column?: number;
}

export const markedSourceLine = (text: string, probs: Probs<IPreTargetingProbsError>): string | null => {
    const at = probs.errors?.find(error => error.line && error.column);
    const source = at?.line ? text.split('\n')[at.line - 1] : undefined;
    if (!at?.column || source === undefined) return null;
    const width = Math.max(1, source.length - at.column + 1);
    return `${source}\n${' '.repeat(at.column - 1)}${'^'.repeat(width)}`;
};
